
import  { IClaimTypeRecord, ClaimTypeCrudClassProxy, claimTypeCrudClassProxy } from '@src/framework/crud/ticket/ClaimTypeCrud';
import RecordEditor from '@framework/forms/recordeditor';

export default class ClaimTypeEditor extends RecordEditor<IClaimTypeRecord> {

    public getCrudClassProxy() : ClaimTypeCrudClassProxy { return claimTypeCrudClassProxy;  }  
}